// File: src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import {
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  Search,
  SettingsOutlined,
  ArrowDropDownOutlined,
  SwapHorizOutlined,
} from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import { useDispatch } from "react-redux";
import { setMode } from "state";
import profileImage from "assets/profile.jpeg";
import {
  AppBar,
  Button,
  Box,
  Typography,
  IconButton,
  InputBase,
  Toolbar,
  Menu,
  MenuItem,
  useTheme,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// ✅ NEW
import { performLogout } from "utils/logout";

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const [displayName, setDisplayName] = useState("");

  const roleGroupId = localStorage.getItem("roleGroupId");
  const isSysAdmin = roleGroupId === "1";

  useEffect(() => {
    const name = localStorage.getItem("username") || localStorage.getItem("email") || "User";
    setDisplayName(name);
  }, []);

  const handleGoAdminSwitch = () => {
    handleClose();
    navigate("/admin-switch", { replace: true });
  };

  const handleLogout = async () => {
    handleClose();
    await performLogout({ dispatch, navigate });
  };

  return (
    <AppBar sx={{ position: "static", background: "none", boxShadow: "none" }}>
      <Toolbar sx={{ justifyContent: "space-between", gap: { xs: 1, md: 2 }, px: { xs: 1, sm: 2 } }}>
        {/* LEFT SIDE */}
        <FlexBetween sx={{ flex: 1, minWidth: 0, gap: { xs: 0.5, sm: 1 } }}>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton>
          <FlexBetween
            backgroundColor={theme.palette.background.alt}
            borderRadius="9px"
            gap={{ xs: "0.5rem", sm: "1rem", md: "3rem" }}
            p={{ xs: "0.05rem 0.5rem", sm: "0.1rem 1rem", md: "0.1rem 1.5rem" }}
            sx={{ minWidth: 0, flex: 1, maxWidth: { xs: "100%", sm: 320, md: 420 } }}
          >
            <InputBase placeholder="Search..." sx={{ minWidth: 0, width: "100%" }} />
            <IconButton>
              <Search />
            </IconButton>
          </FlexBetween>
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween gap={{ xs: "0.25rem", sm: "0.75rem", md: "1rem" }} sx={{ flexShrink: 0 }}>
          <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlined sx={{ fontSize: "25px" }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: "25px" }} />
            )}
          </IconButton>
          <IconButton>
            <SettingsOutlined sx={{ fontSize: "25px" }} />
          </IconButton>

          <FlexBetween sx={{ minWidth: 0 }}>
            <Button
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: "1rem",
              }}
            >
              <Box
                component="img"
                alt="profile"
                src={profileImage}
                height="32px"
                width="32px"
                borderRadius="50%"
                sx={{ objectFit: "cover" }}
              />
              {!isMobile && (<Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{ color: theme.palette.secondary[100] }}
                >
                  {user?.name || displayName}
                </Typography>
                <Typography fontSize="0.75rem" sx={{ color: theme.palette.secondary[200] }}>
                  {user?.occupation || ""}
                </Typography>
              </Box>)}
              {!isMobile && <ArrowDropDownOutlined sx={{ color: theme.palette.secondary[300], fontSize: "25px" }} />}
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              {isSysAdmin && (
                <MenuItem onClick={handleGoAdminSwitch}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <SwapHorizOutlined fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Admin Switch" />
                </MenuItem>
              )}

              <MenuItem onClick={handleLogout}>
                <ListItemText primary="Log Out" />
              </MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;